import * as yup from 'yup'

export const getAssetConfigurationValidationSchema = () => {
  return yup.object({
    name: yup.string().required('Name is required'),
    transportModeId: yup.number().required('Transport Mode is required'),
  })
}
